<template>
	<app-header-teleport>
		<app-title title="Menu" />
	</app-header-teleport>
	<div class="flex flex-col p-4">
		<div class="flex justify-between items-center">
			<marketing-select
				v-if="renderSelect"
				id="menuSelect"
				:label="$t('menuType')"
				:object="true"
				:canDeselect="false"
				:options="activeMenuTypes"
				:modelValue="selectedMenuType"
				@select="changeMenuType"
			/>
			<div v-if="inActiveMenuTypes.length" class="dropdown relative">
				<app-button class="btn btn-success transparent" icon="plus"> {{ $t('add') }} Menu </app-button>
				<ul class="dropdown-menu absolute hidden text-gray-700 pt-1">
					<li v-for="menuType in inActiveMenuTypes" :key="menuType.code" class="">
						<a
							class="bg-white hover:bg-success hover:text-white py-2 px-4 block whitespace-no-wrap"
							@click="createMenu(menuType.code)"
						>
							{{ menuType.description }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<menu-table
			v-if="menu.length"
			:categories="menu"
			:loading="loadingTable"
			:business-id="businessId"
			:menu-type="selectedMenuType.code"
			:canEditMenu="canEditBusinessMenu"
			@categoryMove="moveCategory"
			@menuItemMove="moveMenuItem"
			@createProduct="createProductHandler"
			@editProduct="editProductHandler"
			@statusChange="changeMenuItemStatus"
			@editCategories="initEditCategories"
			@categoryChange="changedCategory = $event"
			@getCategories="getCategories(selectedMenuType.code)"
			@showImage="showImage"
		/>
	</div>

	<app-section v-if="!loading && !activeMenuTypes.length" class="max-w-xl mx-auto">
		<div class="text-center p-10">
			<p class="text-lg font-semibold mb-6">
				Restoranti nuk ka ende nje menu
			</p>
			<p>
				Ju lutem verifikoni te keni menune e axhornuar te Biznesit dhe te keni foto me kualitet te larte.
				Verifikoni permasat dhe dimensionin e fotove perpara se ti karikoni.
			</p>
			<div class="pt-6">
				<div class="dropdown inline-block relative w-full">
					<ul class="dropdown-menu absolute hidden text-gray-700 pt-1 w-full">
						<li v-for="menuType in menuTypes" :key="menuType.code" class="">
							<a
								class="bg-white hover:bg-success hover:text-white py-2 px-4 block whitespace-no-wrap"
								@click="createMenu(menuType.code)"
							>
								{{ menuType.description }}
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</app-section>
	<categories-section
		v-if="!loading && newMenu === selectedMenuType.code"
		:loading="loading"
		@submit="submitMenu($event, 'create')"
	/>
	<product-form
		:show="productFormModal"
		:business-id="businessId"
		:product="selectedProduct"
		:menu-type="selectedMenuType"
		:categories="menu"
		:changedCategory="changedCategory"
		:storeTypeId="getStoreTypeId"
		:canEditMenu="canEditBusinessMenu"
		:canEditItemPrice="canEditItemPrice"
		@create="productCreated"
		@update="productUpdated"
		@close="closeProductFormModal"
		@createProduct="createProductHandler"
		@showImage="showImage"
	/>
	<app-modal title="Edit Categories" v-if="editingCategories" @close="editingCategories = false">
		<categories-section
			v-if="editingCategories"
			class="h-72"
			:current-categories="menu"
			@submit="submitMenu($event, 'update')"
		/>
	</app-modal>
	<app-modal v-if="imageModal" :show="imageModal" @close="imageModal = false" @click.self="imageModal = false">
		<div class="flex flex-col items-center justify-center">
			<img :src="selectedImage" class="image-modal" alt="" />
		</div>
	</app-modal>
</template>

<script>
	import MenuService from '@/services/sales/MenuService';
	import AppButton from '@/components/app/AppButton';
	import MenuTable from '@/components/sales/menu/Table';
	import UtilityService from '@/services/UtilityService';
	import ProductForm from '@/components/sales/menu/ProductForm';
	import MarketingSelect from '@/components/marketing/forms/formComponents/MarketingSelect';
	import CategoriesSection from '@/components/sales/menu/CategoriesSection';
	import AppModal from '@/components/app/AppModal';
	import { mapGetters } from 'vuex';
	import BusinessService from '@/services/sales/BusinessService';

	export default {
		name: 'MenuList',
		components: {
			AppModal,
			CategoriesSection,
			MarketingSelect,
			ProductForm,
			MenuTable,
			AppButton,
		},
		data: () => ({
			filters: {
				userSearch: '',
			},
			menuTypes: [],
			loading: false,
			loadingTable: false,
			newMenu: null,
			selectedProduct: {},
			selectedMenuType: {},
			menu: [],
			productFormModal: false,
			renderSelect: true,
			editingCategories: false,
			changedCategory: null,
			imageModal: false,
			selectedImage: null,
		}),
		computed: {
			...mapGetters({
				user: 'user',
			}),
			businessId() {
				if (this.$route.params.id) {
					return this.$route.params.id;
				}
				return this.user.restaurants[0].restaurantID;
			},
			getStoreTypeId() {
				if (this.$route.params.id) {
					return this.user.restaurants.find(
						(restaurant) => Number(restaurant.restaurantID) == Number(this.$route.params.id)
					).storeTypeId;
				}
				return this.user.restaurants[0].storeTypeId;
			},
			activeMenuTypes() {
				return this.menuTypes.filter((menuType) => menuType.hasMenuType);
			},
			inActiveMenuTypes() {
				return this.menuTypes.filter((menuType) => !menuType.hasMenuType);
			},
			canEditItemPrice() {
				return BusinessService.canEditMenuItemPrice();
			},
			canEditBusinessMenu() {
				return BusinessService.canEditBusinessMenu();
			},
		},
		methods: {
			initEditCategories() {
				this.editingCategories = true;
			},
			changeMenuItemStatus(category, item, status) {
				const fallbackMenu = [...this.menu];
				let catIndex = this.menu.findIndex((_cat) => _cat.id === category.id);
				let productIndex = this.menu[catIndex].menuCategory.menuItems.findIndex(
					(_item) => _item.id === item.id
				);
				MenuService.updateMenuItemStatus(this.businessId, this.selectedMenuType.code, item.id, status)
					.then(() => {
						this.menu[catIndex].menuCategory.menuItems[productIndex].status = status;
						this.$notificationService.success('Product Status Changed!');
					})
					.catch((e) => {
						this.$notificationService.error(e);
						this.menu = fallbackMenu;
					});
			},
			changeMenuType(menuType) {
				this.emitter.emit('isLoading', true);
				this.menu = [];
				this.selectedMenuType = menuType;
				this.getCategories(menuType.code);
			},
			createProductHandler() {
				this.selectedProduct = {};
				this.productFormModal = true;
				if (this.menu.length && this.changedCategory == null) this.changedCategory = { id: this.menu[0].id };
			},
			editProductHandler(product) {
				this.loadingTable = true;
				if (this.menu.length && this.changedCategory == null) this.changedCategory = { id: this.menu[0].id };
				MenuService.getMenuItemById(this.businessId, this.selectedMenuType.code, product.id).then((res) => {
					this.selectedProduct = res;
					this.productFormModal = true;
					this.loadingTable = false;
				});
			},
			getCategories(menuType = this.selectedMenuType.code) {
				this.loadingCategories = true;
				this.menu = [];
				MenuService.getBusinessCategoriesByMenuType(this.businessId, menuType, this.filters)
					.then((res) => {
						this.menu = res;
						if (this.changedCategory === null) {
							this.changedCategory = res[0];
						}
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.emitter.emit('isLoading', false);
						this.loadingCategories = false;
					});
			},
			getMenuTypes() {
				this.loading = true;
				MenuService.getMenuTypes(this.businessId)
					.then((res) => {
						this.loading = false;
						this.menuTypes = res;
						let _selectedMenuType = res.find((menuType) => menuType.hasMenuType) || {};
						this.selectedMenuType = _selectedMenuType;
						if (_selectedMenuType) {
							this.getCategories(this.selectedMenuType.code);
						}
						this.reRenderSelect();
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.loading = false;
						this.emitter.emit('isLoading', false);
					});
			},
			createMenu(menuTypeCode) {
				let menuTypeIndex = this.menuTypes.findIndex((menuType) => menuType.code === menuTypeCode);
				this.menuTypes[menuTypeIndex].hasMenuType = 1;
				this.selectedMenuType = this.menuTypes[menuTypeIndex];
				this.menu = [];
				this.newMenu = menuTypeCode;
			},
			submitMenu(selectedCategories, action) {
				this.loading = true;
				let payload = {
					menuBusinessCategories: selectedCategories.map((cat, i) => ({
						orderNo: i + 1,
						menuCategory: { id: cat.id },
					})),
				};
				const endpoint = action === 'create' ? 'createMenu' : 'updateMenu';
				MenuService[endpoint](this.businessId, this.selectedMenuType.code, payload)
					.then(() => {
						this.newMenu = null;
						this.editingCategories = false;
						this.emitter.emit('isLoading', true);
						this.getCategories();
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.loading = false;
					});
			},
			moveCategory({ element, oldIndex, newIndex }) {
				const currentOrder = [...this.menu];
				this.menu = UtilityService.reOrderItems(currentOrder, oldIndex, newIndex);
				MenuService.menuCategoryReorder(this.businessId, this.selectedMenuType.code, element.id, newIndex + 1)
					.then(() => this.$notificationService.success('Category Moved Successfully!'))
					.catch((error) => {
						this.$notificationService.error(error);
						this.menu = currentOrder;
					});
			},
			moveMenuItem({ element, oldIndex, newIndex }, selectedCategory) {
				let categoryIndex = this.menu.findIndex((_cat) => _cat.id === selectedCategory.id);
				const currentOrder = [...this.menu[categoryIndex].menuCategory.menuItems];
				this.menu[categoryIndex].menuCategory.menuItems = UtilityService.reOrderItems(
					[...this.menu[categoryIndex].menuCategory.menuItems],
					oldIndex,
					newIndex
				);
				MenuService.menuItemReorder(this.businessId, this.selectedMenuType.code, element.id, newIndex + 1)
					.then(() => this.$notificationService.success('Product Moved Successfully!'))
					.catch((error) => {
						this.$notificationService.error(error);
						this.menu[categoryIndex].menuCategory.menuItems = currentOrder;
					});
			},
			productCreated() {
				this.emitter.emit('isLoading', true);
				this.closeProductFormModal();
				this.getCategories();
			},
			productUpdated() {
				this.emitter.emit('isLoading', true);
				this.closeProductFormModal();
				this.getCategories();
			},
			closeProductFormModal() {
				this.productFormModal = false;
				this.selectedProduct = {};
			},
			reRenderSelect() {
				this.renderSelect = false;
				this.$nextTick(() => {
					this.renderSelect = true;
				});
			},
			showImage(image) {
				this.imageModal = true;
				this.selectedImage = image;
			},
		},
		mounted() {
			this.emitter.emit('isLoading', true);
			this.getMenuTypes();
		},
	};
</script>

<style lang="scss" scoped>
	.dropdown:hover .dropdown-menu {
		@apply block bg-white z-10 cursor-pointer border-default;
	}
	:deep(.modal-body) {
		max-height: 90vh;
		@apply p-8;
	}
	.image-modal {
		max-width: calc(100vw - 224px);
		max-height: calc(100vh - 164px);
	}
</style>
